export const ANALYTICS_REPORT_SUCCESS="analytics/ANALYTICS_REPORT_SUCCESS";
export const ANALYTICS_REPORT_FAILURE="analytics/ANALYTICS_REPORT_FAILURE";